'use client'

import { ArrowRight } from 'lucide-react'
import React, { useEffect, useState } from 'react'
import RichText from '@/components/RichText'

export const ServicesThree = (props: any) => {
  const { services, title, subtitle } = props
  const [hoveredItem, setHoveredItem] = useState<any | null>(null)
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 })

  // ...existing code...

  const handleMouseMove = (e: React.MouseEvent) => {
    setMousePos({ x: e.clientX, y: e.clientY })
  }

  return (
    <main
      className="relative overflow-hidden z-[1] pb-[114px]"
      aria-label="Services"
      onMouseMove={handleMouseMove}
    >
      <section className="container mx-auto">
        {title && (
          <header className="mb-6">
            <RichText
              data={title}
              enableGutter={false}
              enableProse={false}
              className="text-2xl md:text-3xl lg:text-4xl font-bold  mb-2"
            />
            {subtitle && (
              <RichText
                data={subtitle}
                enableGutter={false}
                enableProse={false}
                className="text-lg md:text-xl text-muted-foreground"
              />
            )}
          </header>
        )}
        <ul className="relative list-none">
          {services?.map((item: any, index: any) => (
            <li
              key={index}
              className={`relative block border-b border-muted-foreground py-9 ${
                index === 0 ? 'border-t' : ''
              } group`}
              onMouseEnter={() => setHoveredItem(item)}
              onMouseLeave={() => setHoveredItem(null)}
            >
              <article className="relative flex flex-col md:flex-row md:items-center overflow-hidden">
                <nav aria-label="Service link" className="absolute left-0 top-1/2 -translate-y-1/2">
                  <a
                    href="#"
                    className="block -translate-x-[82px] opacity-0 transition-all duration-500 ease-in-out group-hover:translate-x-0 group-hover:opacity-100 focus:translate-x-0 focus:opacity-100"
                    tabIndex={0}
                    aria-label={`Go to ${item.title}`}
                  >
                    <ArrowRight className="text-[20px] text-muted-foreground" />
                  </a>
                </nav>
                <div className="w-full md:max-w-[245px] transition-all duration-500 group-hover:ml-[110px]">
                  <p className="text-muted-foreground text-base md:text-lg">{item.eyebrow}</p>
                </div>
                {item.title && (
                  <RichText
                    data={item.title}
                    enableGutter={false}
                    enableProse={false}
                    className="text-[22px] md:text-[26px] font-bold leading-[32px] md:leading-[36px] ml-0 md:ml-6 mt-2 md:mt-0 hover:underline focus:underline"
                  />
                )}
              </article>
            </li>
          ))}
        </ul>
      </section>

      {hoveredItem && (
        <div
          className="pointer-events-none fixed z-50 transition-all duration-300 ease-out hidden md:block"
          style={{
            top: mousePos.y + 20,
            left: mousePos.x + 20,
            width: 325,
            height: 356,
            transform: 'translate(-100%, -50%) rotate(0deg) scale(1,1)',
          }}
        >
          <img
            src={hoveredItem.image?.url}
            alt="Hover Preview"
            className="w-full h-full object-cover picture-rounded shadow-lg transition-transform duration-300 ease-out"
          />
        </div>
      )}
    </main>
  )
}
